import React, { useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { Modal } from 'react-bootstrap'
import Swal from 'sweetalert2'
import { KTIcon } from '../../../_metronic/helpers'
import { axiosClientAuth } from '../../utils'

const UserManagementRightToolbar = () => {
  const [input, setInput] = useState({ name: '', phone: '', email: '', groups: '' })
  const [show, setShow] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const queryClient = useQueryClient()

  const { data: roles = [] } = useQuery(
    ['roles-for-add-user'],
    () =>
      axiosClientAuth
        .get('/auth/roles/', { params: { page: 1, page_size: 100 } })
        .then((res) => res.data?.data?.results ?? []),
    { enabled: show }
  )

  const resetForm = () => {
    setShow(false)
    setInput({ name: '', phone: '', email: '', groups: '' })
  }

  const onChangeHandler = (e) => {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    if (!input.groups) {
      Swal.fire({ titleText: 'Error!', text: 'Please select a role.', icon: 'error', confirmButtonText: 'Ok' })
      return
    }
    setSubmitting(true)
    try {
      const createRes = await axiosClientAuth.post(
        '/auth/users/create/',
        { name: input.name, email: input.email, phone: input.phone, type: 'AD' },
        {
          transformResponse: [
            (raw: string) => {
              const safe = raw.replace(/"id"\s*:\s*(\d{15,})/g, '"id":"$1"')
              return JSON.parse(safe)
            },
          ],
        }
      )
      const userId = createRes.data?.data?.id
      await axiosClientAuth.post(`/auth/users/${userId}/assign-role/`, {
        role_id: parseInt(input.groups),
      })
      await Swal.fire({ titleText: 'Success!', text: 'User Created Successfully', icon: 'success', confirmButtonText: 'Ok' })
      resetForm()
      queryClient.invalidateQueries(['users'])
    } catch (err: any) {
      Swal.fire({
        titleText: 'Error!',
        text: err?.response?.data?.message || 'Failed to create user',
        icon: 'error',
        confirmButtonText: 'Ok',
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <button
        className='btn btn-sm fw-bold btn-primary'
        onClick={() => setShow(true)}
      >
        Add User
      </button>

      <Modal show={show} className='modal fade modal-lg'>
        <div className='modal-header'>
          <h2 className='fw-bold'>Add User</h2>
          <div className='d-flex justify-content-end'>
            <button
              className='ms-auto btn btn-sm btn-icon btn-active-color-primary'
              onClick={resetForm}
            >
              <KTIcon iconName='cross' className='text-gray fs-1' />
            </button>
          </div>
        </div>
        <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
          <form className='form' onSubmit={onSubmit}>
            <div className='d-flex flex-column scroll-y me-n7 pe-7'>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Full Name</label>
                <input
                  type='text'
                  name='name'
                  required
                  value={input.name}
                  onChange={onChangeHandler}
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  placeholder='Full name'
                />
              </div>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Email ID</label>
                <input
                  type='email'
                  name='email'
                  required
                  value={input.email}
                  onChange={onChangeHandler}
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  placeholder='example@domain.com'
                />
              </div>
              <div className='fv-row mb-7'>
                <label className='required fw-semibold fs-6 mb-2'>Phone</label>
                <input
                  type='text'
                  name='phone'
                  required
                  value={input.phone}
                  onChange={onChangeHandler}
                  className='form-control form-control-solid mb-3 mb-lg-0'
                  placeholder='1234567890'
                />
              </div>
              <div className='mb-7'>
                <label className='required fw-semibold fs-6 mb-5'>Role</label>
                {roles.map((role: any) => (
                  <React.Fragment key={role.id}>
                    <div className='d-flex fv-row'>
                      <div className='form-check form-check-custom form-check-solid'>
                        <input
                          className='form-check-input me-3'
                          name='groups'
                          type='radio'
                          value={String(role.id)}
                          checked={input.groups === String(role.id)}
                          onChange={onChangeHandler}
                        />
                        <label className='form-check-label'>
                          <div className='fw-bold text-gray-800'>{role.name}</div>
                          <div className='text-gray-600'>{role.description}</div>
                        </label>
                      </div>
                    </div>
                    <div className='separator separator-dashed my-5' />
                  </React.Fragment>
                ))}
              </div>
            </div>
            <div className='text-center pt-15'>
              <button type='reset' className='btn btn-light me-3' onClick={resetForm}>
                Discard
              </button>
              <button type='submit' className='btn btn-primary' disabled={submitting}>
                {submitting ? (
                  <span className='indicator-progress d-flex align-items-center'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2' />
                  </span>
                ) : (
                  <span className='indicator-label'>Submit</span>
                )}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

export default UserManagementRightToolbar
